(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         *
         */
        .factory('messageService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;

                    var fac = {
                        getMessage: getMessage,
                        redactMessage: redactMessage,
                        redactChatMessage: redactChatMessage,
                    };

                    return fac;

                    function requestComplete(response) {
                        return response.data;
                    }

                    function requestFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }

                    function redactChatMessage(id, chatId, messageId) {
                        // urlBase = 'http://localhost:8002';
                        return $http.patch(urlBase + "/apispaces/" + id + "/chats/" + chatId + "/messages/" + messageId, { "redact": true })
                            .then(requestComplete)
                            .catch(requestFailed);

                    }

                    function redactMessage(id, messageId, direction) {
                        // urlBase = 'http://localhost:8003';
                        direction = direction === "inbound" ? "/messages/inbounds/" : "/messages/";
                        let route = urlBase + "/apispaces/" + id + direction + messageId;
                        return $http.patch(route, { "redact": true })
                            .then(requestComplete)
                            .catch(requestFailed);
                    }

                    function getMessage(id, messageId) {
                        return $http.get(urlBase + "/apispaces/" + id + "/messages/" + messageId)
                            .then(requestComplete)
                            .catch(requestFailed);
                    }
                }]);
})(window.angular);
